import { v5 as uuid5 } from 'uuid';

// Emarsys namespace for contact UUID generation
const EMARSYS_NAMESPACE = '64525bc0-03a1-4d1f-b342-1f53a5061697';

/**
 * Generates a contact UUID for Emarsys tracking
 * Sanitizes the email (lowercase and trim) before generating the UUID
 * @param email - The user's email address
 * @returns The generated UUID string
 */
export function generateContactUuid(email: string): string {
  if (!email) {
    return '';
  }

  // Sanitize email: lowercase and trim whitespace
  const sanitizedEmail = email.toLowerCase().trim();

  return uuid5(sanitizedEmail, EMARSYS_NAMESPACE);
}
